import { SwitchCheckbox } from '@/components/SwitchCheckbox'
import styles from './SkillToggles.module.css'

export interface SkillToggle {
  id: string
  name: string
  isSelected: boolean
}

export interface SkillTogglesProps {
  skills: SkillToggle[]
  onToggle: (skillId: string) => unknown
  testId?: string
}

/**
 * A switch for each skill the pro may have.
 */
export function SkillToggles({ skills, onToggle, testId }: SkillTogglesProps) {
  return (
    <div className={styles.root} data-test={testId}>
      {skills.map((skill) => (
        <div key={skill.id} className={styles.skill}>
          <span className={styles.name}>{skill.name}</span>
          <SwitchCheckbox
            noText
            value={skill.isSelected}
            onChange={() => onToggle(skill.id)}
            testId={testId && `${testId}-${skill.id}`}
          />
        </div>
      ))}
    </div>
  )
}
